import { OrderInsightJacket } from 'api/file/interfaces/get-file-order-insights';
import { Jacket } from './types';

export function isCountyRequiredError(error: unknown): boolean {
  if (!error) {
    return false;
  }

  if (typeof error === 'object' && error !== null && 'messages' in error) {
    const messages = (error as { messages?: string[] }).messages ?? [];
    if (messages.some((message) => message.toLowerCase().includes('property county'))) {
      return true;
    }
  }

  if (error instanceof Error) {
    return error.message.toLowerCase().includes('property county');
  }

  return String(error).toLowerCase().includes('property county');
}

export function mapOrderInsightJacketsToJackets(orderInsightJackets: OrderInsightJacket[]): Jacket[] {
  return orderInsightJackets.map((jacket) => ({
    jacketId: jacket.fileServiceJacketId,
    policyNumber: jacket.policyNumber,
    formNumber: '',
    policyType: jacket.policyType,
    policyStatus: jacket.policyStatus,
    policyAmount: jacket.liabilityAmount ?? 0,
    rateType: 0,
    policyFields: [],
    jacketEndorsements: [],
    jacketIncorporatedEndorsements: [],
    randomId: `order-insight-${jacket.fileServiceJacketId}`,
    expanded: true,
    status: jacket.policyStatus,
    lenderId: 0,
  }));
}
